import { render, staticRenderFns } from "./priceListTemplateNew.vue?vue&type=template&id=761db8fa&"
import script from "./priceListTemplateNew.vue?vue&type=script&lang=js&"
export * from "./priceListTemplateNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports